import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useEffect, useMemo } from 'react';
import { getStockMeta } from '../actions';
export const lastAPICallTimes = {};
const useStockMeta = (assetId) => {
    const id = useAppSelector((state) => state.invest.caches[assetId]?.id);
    const name = useAppSelector((state) => state.invest.caches[assetId]?.name);
    const symbol = useAppSelector((state) => state.invest.caches[assetId]?.symbol);
    const iconUrl = useAppSelector((state) => state.invest.caches[assetId]?.iconUrl);
    const description = useAppSelector((state) => state.invest.caches[assetId]?.description);
    const shortDescription = useAppSelector((state) => state.invest.caches[assetId]?.shortDescription);
    const averageAnnualReturn = useAppSelector((state) => state.invest.caches[assetId]?.averageAnnualReturn);
    const ceo = useAppSelector((state) => state.invest.caches[assetId]?.ceo);
    const sector = useAppSelector((state) => state.invest.caches[assetId]?.sector);
    const website = useAppSelector((state) => state.invest.caches[assetId]?.website);
    const employees = useAppSelector((state) => state.invest.caches[assetId]?.employees);
    const headquarters = useAppSelector((state) => state.invest.caches[assetId]?.headquarters);
    const pe = useAppSelector((state) => state.invest.caches[assetId]?.pe);
    const eps = useAppSelector((state) => state.invest.caches[assetId]?.eps);
    const beta = useAppSelector((state) => state.invest.caches[assetId]?.beta);
    const marketCap = useAppSelector((state) => state.invest.caches[assetId]?.marketCap);
    const forwardPe = useAppSelector((state) => state.invest.caches[assetId]?.forwardPe);
    const dividendRate = useAppSelector((state) => state.invest.caches[assetId]?.dividendRate);
    const dividendYield = useAppSelector((state) => state.invest.caches[assetId]?.dividendYield);
    const fundTheme = useAppSelector((state) => state.invest.caches[assetId]?.fundTheme);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if ((!name || !iconUrl || !description || !id) && assetId) {
            const timeout = setTimeout(() => {
                // schedule a macro task to avoid multiple API requests for the same thing.
                // This is a good way to wait for somebody else to fetch this metadata.
                // For example StockScreen fetches the same endpoint for its own use.
                if (!lastAPICallTimes[assetId] || new Date().getTime() - lastAPICallTimes[assetId] > 2000) {
                    lastAPICallTimes[assetId] = new Date().getTime();
                    dispatch(getStockMeta(assetId));
                }
            });
            return () => {
                clearTimeout(timeout);
            };
        }
        return () => { };
    }, [description, iconUrl, name, assetId, id]);
    return useMemo(() => ({
        id: assetId,
        name,
        symbol,
        iconUrl,
        description,
        shortDescription,
        averageAnnualReturn,
        fundTheme,
        ceo,
        sector,
        website,
        employees,
        headquarters,
        pe,
        eps,
        beta,
        marketCap,
        forwardPe,
        dividendRate,
        dividendYield,
    }), [
        assetId,
        name,
        symbol,
        iconUrl,
        description,
        shortDescription,
        averageAnnualReturn,
        ceo,
        sector,
        website,
        employees,
        headquarters,
        pe,
        eps,
        beta,
        marketCap,
        forwardPe,
        dividendRate,
        dividendYield,
        fundTheme,
    ]);
};
export default useStockMeta;
